import React, { Component } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import ThemeContainer from 'common/containers/ThemeContainer';

import CannySDK from '../CannySDK';
import Helmet from '../helmets/Helmet';
import loadScript from '../util/loadScript';

CannySDK.init();

import 'css/components/webview/_Webview.scss';

const IntercomSheetLibraryID = 'intercom-sheet-library';
const IntercomSheetLibraryURL = 'https://js.intercomcdn.com/messenger-sheet-library.latest.js';

export default class Webview extends Component {
  static propTypes = {
    location: PropTypes.object,
  };

  componentDidMount() {
    const {
      location: { query },
    } = this.props;
    const { boardToken, display, ssoToken, intercomTitle, theme } = query;

    Canny('render', {
      basePath: '/',
      boardToken,
      ...(ssoToken && {
        ssoToken,
      }),
      ...(display && {
        display,
      }),
      theme,
    });

    if (display !== 'intercom' || !intercomTitle) {
      return;
    }

    loadScript(IntercomSheetLibraryURL, IntercomSheetLibraryID, {
      callback: () => {
        window.INTERCOM_MESSENGER_SHEET_LIBRARY.setTitle(intercomTitle);
      },
      waitForLoad: false,
    });
  }

  render() {
    const {
      location: { query },
    } = this.props;
    const { display, theme } = query;

    return (
      <ThemeContainer configTheme={theme}>
        <div className={classnames('webview', { intercom: display === 'intercom' })} data-canny>
          <Helmet title="Feedback" />
        </div>
      </ThemeContainer>
    );
  }
}
